import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

const CURRENCY_LOCALES_DICT: { [currencyCode: Uppercase<string>]: string } = {
  /* eslint-disable @typescript-eslint/naming-convention */
  NOK: 'nb',
  EUR: 'en',
  /* eslint-enable */
};

@Pipe({
  name: 'nkCurrency',
  standalone: true,
})
export class NkCurrencyPipe implements PipeTransform {
  constructor(private _currencyPipe: CurrencyPipe) {}

  public transform(
    value: number | string | null | undefined,
    currencyCode: Uppercase<string>,
    digitsInfo = '1.0-0',
  ): string | null {
    const localeId = CURRENCY_LOCALES_DICT[currencyCode];
    return this._currencyPipe.transform(value, currencyCode, 'code', digitsInfo, localeId);
  }
}
